import React from "react";

function RenderAlert() {
  return (
    <div className="px-4 py-3 leading-normal bg-gray-gradient text-secondary font-poppins rounded mb-5 text-center">
      <p>Your Message is submitted successfully !</p>
    </div>
  );
}

export default RenderAlert;